import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { getProductPrice } from '~/utils/ProductPrice';
import CartPopupNotification from './CartPopupNotification.vue';
import { useCartPopup } from '~/composables/_next/cart/useCartPopup';
import { generateVariantString } from '~/utils';
import { useLocalization } from '~/composables/_next/useLocalization';
export default defineComponent({
  name: 'CartPopup',
  components: {
    CartPopupNotification: CartPopupNotification
  },
  setup: function setup() {
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useUiState = useUiState(),
      isCartPopupOpen = _useUiState.isCartPopupOpen,
      hideCartPopup = _useUiState.hideCartPopup,
      toggleCartSidebar = _useUiState.toggleCartSidebar;
    var _useCartPopup = useCartPopup(),
      lastAddedItems = _useCartPopup.lastAddedItems;
    var items = computed(function () {
      return lastAddedItems.value.map(function (_ref) {
        var product = _ref.product,
          quantity = _ref.quantity;
        var name = product.name,
          _name = product._name,
          mainImage = product.mainImage,
          images = product.images;
        var priceUnit = getProductPrice(product);
        var priceRegular = priceUnit.regular * quantity;
        var priceSpecial = priceUnit.special ? priceUnit.special * quantity : null;
        return {
          name: name !== null && name !== void 0 ? name : _name,
          mainImage: mainImage,
          images: images,
          variant: generateVariantString(product, locale),
          priceUnit: priceUnit,
          priceRegular: priceRegular,
          priceSpecial: priceSpecial,
          quantity: quantity
        };
      });
    });
    var priceTotal = computed(function () {
      return items.value.reduce(function (accumulator, item) {
        var _item$priceSpecial;
        var price = (_item$priceSpecial = item.priceSpecial) !== null && _item$priceSpecial !== void 0 ? _item$priceSpecial : item.priceRegular;
        return accumulator + price;
      }, 0);
    });
    var articlesCount = computed(function () {
      return items.value.reduce(function (a, item) {
        return a + item.quantity;
      }, 0);
    });
    var openCart = function openCart() {
      hideCartPopup();
      toggleCartSidebar();
    };
    return {
      openCart: openCart,
      isCartPopupOpen: isCartPopupOpen,
      hideCartPopup: hideCartPopup,
      toggleCartSidebar: toggleCartSidebar,
      items: items,
      priceTotal: priceTotal,
      articlesCount: articlesCount
    };
  }
});